import { CampaignTwoTone } from "@mui/icons-material";

const CampaignIcon = () => {
  return <CampaignTwoTone />;
};

export default CampaignIcon;
